/* eslint-disable @typescript-eslint/ban-types */
import { useState } from 'react';
import { useStore } from 'react-redux';
import { AnyAction } from 'redux';
import { RootState } from 'store/store';
import {
  IBaseComponentParams,
  IBaseComponentReturnType,
  IBaseState,
  IBaseVoidProps,
} from './base-type';

export const useBaseComponent = <
  P extends IBaseVoidProps = {},
  S extends IBaseState = {},
  H = any,
>(
  params?: IBaseComponentParams<P, S>
): IBaseComponentReturnType<S, H> => {
  const {
    props = {} as P,
    initialState = {} as S,
    helperHook,
  } = params ?? {
    initialState: {} as S,
  };

  const [state, pureSetState] = useState<S>(initialState);

  const { getState } = useStore<RootState, AnyAction>();

  const store: RootState = getState();

  const setState = (newState: Partial<S>) => {
    pureSetState({
      ...state,
      ...newState,
    });
  };

  const helper = helperHook?.({
    props,
    state,
    store,
    setState,
    pureSetState,
  });

  return {
    state,
    helper,
    store,
    setState,
    pureSetState,
  };
};
